// ===== Enums =====

export enum CustomFieldDataType {
  Boolean = 'Boolean',
  Date = 'Date',
  DateTime = 'DateTime',
  Integer = 'Integer',
  Number = 'Number',
  String = 'String',
}

export enum CustomFieldType {
  None = 'None',
  SelectMany = 'SelectMany',
  SelectOne = 'SelectOne',
}

// ===== Supporting Models =====

export interface CustomFieldOption {
  name: string | null;
  value: string | null;
}

// ===== View Models =====

export interface AuthProviderViewModel {
  federatedAuthProviderId: string;
  name: string | null;
  authProviderType: string;
  issuer: string | null;
  clientId: string | null;
  microsoftTenantId: string | null;
  configurationUri: string | null;
  supportedScopes: string[] | null;
  disabled: boolean;
}

export interface CustomFieldViewModel {
  tenantId: string;
  createdDate: string;
  createdBy: string;
  updatedDate: string | null;
  updatedBy: string | null;
  customFieldId: number;
  name: string | null;
  dataType: CustomFieldDataType;
  inactive: boolean;
  fieldType: CustomFieldType;
  options: CustomFieldOption[] | null;
}

// ===== Request Models =====

export interface CreateOrUpdateCustomFieldViewModel {
  customFieldId?: number | null;
  name: string | null;
  dataType: CustomFieldDataType;
  fieldType: CustomFieldType;
  inactive: boolean;
  options: CustomFieldOption[] | null;
}

